import { money } from "./money";
export interface Compensation {
  id: string;
  task_id: string;
  app_id: string;
  person_id: string;
  amount: number;
  generation_id: string;
  reason: string;
  occurred_at: string;
}
export interface RevenueAdjustment {
  compensation_id: string;
  task_id: string;
  gross_delta: number;
  provider_cost_delta: number;
  margin_delta: number;
  owner_cost: number;
  occurred_at: string;
}
export function AICompensations({
  compensations,
  adjustments,
}: {
  compensations: Compensation[];
  adjustments: RevenueAdjustment[];
}) {
  return (
    <section aria-label="Компенсации оплаченных AI-ошибок">
      <h3>Компенсации клиенту</h3>
      <p>
        Возвращённая сумма уже включена в баланс и леджер кошелька.
        Первоначальные списания и AI-задачи сохраняются в истории.
      </p>
      {compensations.length ? (
        <div className="table-scroll">
          <table>
            <thead>
              <tr>
                <th>Дата</th>
                <th>Задача / приложение</th>
                <th>Возвращено RUB</th>
                <th>Generation ID</th>
                <th>Причина</th>
              </tr>
            </thead>
            <tbody>
              {compensations.map((c) => (
                <tr key={c.id}>
                  <td>{new Date(c.occurred_at).toLocaleString("ru-RU")}</td>
                  <td>
                    {c.task_id} / {c.app_id}
                  </td>
                  <td>{money(c.amount, "RUB")}</td>
                  <td>{c.generation_id}</td>
                  <td>{c.reason}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      ) : (
        <p>Компенсаций нет</p>
      )}
      <h3>Корректировки выручки и маржи</h3>
      <p>
        Дельты отражают возврат клиенту. Стоимость провайдера уже учтена при
        исходном списании и остаётся расходом владельца; она показана справочно
        и повторно не списывается.
      </p>
      {adjustments.length ? (
        <div className="table-scroll">
          <table>
            <thead>
              <tr>
                <th>Дата</th>
                <th>Задача / компенсация</th>
                <th>Изменение выручки RUB</th>
                <th>Изменение стоимости провайдера RUB</th>
                <th>Изменение маржи RUB</th>
                <th>Расход владельца RUB (справочно)</th>
              </tr>
            </thead>
            <tbody>
              {adjustments.map((a) => (
                <tr key={a.compensation_id}>
                  <td>{new Date(a.occurred_at).toLocaleString("ru-RU")}</td>
                  <td>
                    {a.task_id} / {a.compensation_id}
                  </td>
                  <td>{money(a.gross_delta, "RUB")}</td>
                  <td>{money(a.provider_cost_delta, "RUB")}</td>
                  <td>{money(a.margin_delta, "RUB")}</td>
                  <td>{money(a.owner_cost, "RUB")}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      ) : (
        <p>Корректировок нет</p>
      )}
    </section>
  );
}
